/** @format */
import { post, download } from '@root/utils/httpWrap';

/**
 * 查询锁车列表
 */
export interface IQueryLockListParam {
  parkId: string;
  plateHead: string;
  plateTail: string;
  lockTimeStart: string;
  lockTimeEnd: string;
  status: string; // 状态
  source: string; // 操作来源
  currPage: string | number;
  pageSize: string | number;
}
export const queryLockList = (params: IQueryLockListParam): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/lock/list', params);
};

/**
 * 解锁
 */
export interface IUnlockParam {
  id: string;
}
export const unlock = (params: IUnlockParam): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/lock/unlock', params);
};

/**
 * 获取入场订单（带分页）
 */
export interface IQetEnterOrderParam {
  parkId: string;
  plateHead: string;
  plateTail: string;
  currPage: string | number;
  pageSize: string | number;
}
export const getEnterOrder = (params: IQetEnterOrderParam): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/lock/getEnterOrder', params);
};

/**
 * 锁车
 */
export interface ILockParam {
  parkId: string;
  plate: string;
  phoneNumber: string;
  orderId: string;
  carOwnerName: string;
}
export const lock = (params: ILockParam): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/lock/lock', params);
};
